import axios from '../../axios/ctiConfig';
import ctiRequest from '../../axios/ctiRequests';
import * as actionTypes from './actionTypes';
import {notify} from '../../helpers/utility';

export const agentNotesStart = () => {
  return {
    type: actionTypes.AGENT_NOTES_START,
  };
};

export const agentNotesFail = (error) => {
  return {
    type: actionTypes.AGENT_NOTES_FAIL,
    error: error,
  };
};

export const agentNotesSuccess = (notes) => {
  return {
    type: actionTypes.AGENT_NOTES_SUCCESS,
    notes: notes,
  };
};

export const agentNotes = (agentId, notes, save) => {
  return (dispatch) => {
    dispatch(agentNotesStart());
    ctiRequest['CTI_AGENT_NOTES'].agent_id = agentId;
    ctiRequest['CTI_AGENT_NOTES'].notes = notes;
    ctiRequest['CTI_AGENT_NOTES'].save = save;
    window.clientIP = localStorage.getItem('clientIP') ? localStorage.getItem('clientIP') : '127.0.0.1';
    ctiRequest['CTI_AGENT_NOTES'].ip = window.clientIP;
    axios
      .post('/', ctiRequest['CTI_AGENT_NOTES'])
      .then((result) => {
        if (result.data.response.status === 'SUCCESS') {
          if (save === 'save') {
            notify('Notes successfully updated', 'agent-notes', 'success');
          }
          dispatch(agentNotesSuccess(result.data.response.notes));
        } else {
          if (save === 'save') {
            notify('Notes Error: ' + result.data.response.reason, 'agent-notes');
          }
          dispatch(agentNotesFail(result.data.response.reason));
        }
      })
      .catch((err) => {
        console.log(err);
        if (save === 'save') {
          notify('Notes Error', 'agent-notes');
        }
        dispatch(agentNotesFail(err));
      });
  };
};
